"use strict";

import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import React, { Component } from "react";
import Tooltip from "./Tooltip";
import { observable } from "mobx";
import { observer } from "mobx-react";
var ErrorTooltipTimeout = 3500;
var withErrorTimeout = function withErrorTimeout(WrappedTooltip) {
  var WithErrorTimeout = /*#__PURE__*/function (_Component) {
    _inherits(WithErrorTimeout, _Component);
    var _super = _createSuper(WithErrorTimeout);
    function WithErrorTimeout() {
      var _this;
      _classCallCheck(this, WithErrorTimeout);
      _this = _super.apply(this, arguments);
      _this.showTooltip = false;
      _this.tooltipTimeout = null;
      return _this;
    }
    _createClass(WithErrorTimeout, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;
        this.showTooltip = true;
        this.tooltipTimeout = setTimeout(function () {
          _this2.showTooltip = false;
        }, ErrorTooltipTimeout);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.tooltipTimeout) {
          clearTimeout(this.tooltipTimeout);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var props = this.props;
        return /* @__PURE__ */React.createElement(WrappedTooltip, __spreadValues({
          isError: true,
          show: this.showTooltip
        }, props));
      }
    }]);
    return WithErrorTimeout;
  }(Component);
  __decorateClass([observable.ref], WithErrorTimeout.prototype, "showTooltip", 2);
  WithErrorTimeout = __decorateClass([observer], WithErrorTimeout);
  return WithErrorTimeout;
};
var TooltipWithErrorTimeout = withErrorTimeout(Tooltip);
var ErrorTooltip = function ErrorTooltip(props) {
  var children = props.children,
    renderTooltip = props.renderTooltip;
  return renderTooltip ? /* @__PURE__ */React.createElement(TooltipWithErrorTimeout, __spreadValues({}, props)) : /* @__PURE__ */React.createElement(React.Fragment, null, children);
};
export default ErrorTooltip;
export { TooltipWithErrorTimeout, withErrorTimeout, ErrorTooltipTimeout };